<script lang="ts" setup>
import LabShowroom from '~/components/lab/LabShowroom.vue';
</script>

<template>
  <div class="showroom">
    <LabShowroom :is-public="true" />
  </div>
</template>

<style lang="scss" scoped>
.showroom {
  width: 100%;
  overflow: hidden;
}
</style>
